import React, { useState } from 'react';
import PropTypes from 'prop-types';
import WebPPlayer from '../WebPPlayer';
import './WebPModal.css';

const WebPModal = ({ 
    isOpen, 
    onClose, 
    animatedUrl, 
    giftName = 'WebP Image',
    size = 'medium'
}) => {
    const [isVisible, setIsVisible] = useState(false);

    React.useEffect(() => {
        if (isOpen) {
            setIsVisible(true);
        } else {
            const timer = setTimeout(() => setIsVisible(false), 300);
            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    const handleClose = () => {
        onClose();
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    if (!isVisible) return null;

    return (
        <div 
            className={`webp-modal-overlay ${isOpen ? 'show' : ''}`}
            onClick={handleBackdropClick}
        >
            <div className="webp-modal-container">
                <div className="webp-modal-header">
                    <h3 className="webp-modal-title">
                        {giftName} - WebP Image
                    </h3>
                    <button 
                        className="webp-modal-close"
                        onClick={handleClose}
                        aria-label="Đóng"
                    >
                        ✕
                    </button>
                </div>
                
                <div className="webp-modal-body">
                    <WebPPlayer
                        animatedUrl={animatedUrl}
                        giftName={giftName}
                        className={`modal-view ${size}`}
                        width="100%"
                        height="100%"
                    />
                </div>
            </div>
        </div>
    );
};

WebPModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    animatedUrl: PropTypes.string,
    giftName: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large'])
};

export default WebPModal; 